import JGridAlpha from "./JGridAlpha";

export { JGridAlpha }
export default JGridAlpha
